import { useQueryClient } from 'react-query';
import { ResponseError } from 'superagent';
import { Button, Modal, message } from 'antd';
import {
  DataFeedConfig,
  ListDataFeedConfigResponse,
} from '@cbinsights/externalapiservice/externalapiservice';
import { CaretRightOutlined, PauseOutlined } from '@ant-design/icons';
import { useSetDataFeedActiveMutation } from '../services/hooks';

export const ToggleDataFeedStatusButton = ({
  feed,
  idTeam,
}: {
  feed: DataFeedConfig;
  idTeam: string;
}) => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useSetDataFeedActiveMutation();
  const [modal, contextHolder] = Modal.useModal();

  const action = feed.is_active ? 'Deactivate' : 'Activate';

  const handleOk = async () => {
    try {
      const { data_feed_config: updated } = await mutateAsync({
        id_data_feed: feed.id_data_feed,
        is_active: !feed.is_active,
      });

      if (updated) {
        queryClient.setQueryData<ListDataFeedConfigResponse>(
          ['ListDataFeedConfigResponse', idTeam],
          (prev) => ({
            ...prev,
            data_feed_configs: (prev?.data_feed_configs ?? []).map((config) =>
              config.id_data_feed === updated.id_data_feed ? updated : config
            ),
          })
        );
      }
    } catch (e) {
      const content =
        (e as ResponseError)?.status === 404
          ? `Data feed (${feed.id_data_feed}) no longer exists. It may have already been deleted.`
          : `An error occurred while updating the data feed ${feed.id_data_feed}.`;
      message.error({ content, style: { marginTop: '3vh' } });
    }
  };

  const confirmToggle = () => {
    modal.confirm({
      className: 'text-left',
      title: `${action} Data Feed`,
      content: `Are you sure you want to ${action.toLowerCase()} ${
        feed.data_feed_name
      } (${feed.id_data_feed})?`,
      okText: action,
      okButtonProps: { danger: feed.is_active },
      onOk: handleOk,
      getContainer: false,
    });
  };

  return (
    <>
      <Button
        type="link"
        key="toggle-active"
        onClick={confirmToggle}
        danger={feed.is_active}
      >
        {feed.is_active ? <PauseOutlined /> : <CaretRightOutlined />} {action}
      </Button>
      {contextHolder}
    </>
  );
};
